import {
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_OTP_REQUEST,
  LOGIN_OTP_SUCCESS,
  LOGIN_OTP_FAILURE,
  VERIFY_LOGIN_OTP_REQUEST,
  VERIFY_LOGIN_OTP_SUCCESS,
  VERIFY_LOGIN_OTP_FAILURE,
  RESET_LOGIN_STATE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  LOGOUT,
  GET_ALL_CUSTOMERS_SUCCESS,
  SEND_OTP_REQUEST,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  CLEAR_AUTH_ERROR
} from "./ActionTypes";

const initialState = {
  user: null,
  isLoading: false,
  error: null,
  customers: [],
  otpSent: false,
  otpVerified: false,
  registerSuccess: false,
  // Login 2FA states
  loginOtpSent: false,
  loginEmail: null,
  loginPassword: null,
  loginCooldownSeconds: 120,
  // OTP verification status (for skip OTP on subsequent logins)
  isOtpVerified: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_REQUEST:
    case LOGIN_REQUEST:
      return { ...state, isLoading: true, error: null };

    case REGISTER_SUCCESS:
      return { ...state, isLoading: false, registerSuccess: true, otpSent: false, otpVerified: false };
    case REGISTER_FAILURE:
    case LOGIN_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case LOGIN_SUCCESS:
      return { ...state, isLoading: false, error: null };

    // Login 2FA Cases
    case LOGIN_OTP_REQUEST:
      return { ...state, isLoading: true, error: null };
    case LOGIN_OTP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loginOtpSent: true,
        loginEmail: action.payload.email,
        loginPassword: action.payload.password,
        loginCooldownSeconds: action.payload.cooldownSeconds || 120,
        error: null
      };
    case LOGIN_OTP_FAILURE:
      return { ...state, isLoading: false, error: action.payload, loginOtpSent: false };

    case VERIFY_LOGIN_OTP_REQUEST:
      return { ...state, isLoading: true, error: null };
    case VERIFY_LOGIN_OTP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        loginOtpSent: false,
        loginEmail: null,
        loginPassword: null,
        error: null
      };
    case VERIFY_LOGIN_OTP_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case RESET_LOGIN_STATE:
      return {
        ...state,
        loginOtpSent: false,
        loginEmail: null,
        loginPassword: null,
        error: null
      };

    // OTP Cases (Registration)
    case SEND_OTP_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SEND_OTP_SUCCESS:
      return { ...state, isLoading: false, otpSent: true, error: null };
    case SEND_OTP_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case VERIFY_OTP_REQUEST:
      return { ...state, isLoading: true, error: null };
    case VERIFY_OTP_SUCCESS:
      return { ...state, isLoading: false, otpVerified: true, error: null };
    case VERIFY_OTP_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case CLEAR_AUTH_ERROR:
      return { ...state, error: null };

    case GET_USER_REQUEST:
      return { ...state, isLoading: true, error: null, fetchingUser: true };
    case GET_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        user: action.payload,
        fetchingUser: false,
        // Track if user has verified OTP before (for skip OTP logic)
        isOtpVerified: action.payload?.isOtpVerified || false,
      };
    case GET_ALL_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        customers: action.payload,
      };
    case GET_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        fetchingUser: false,
      };
    case LOGOUT:
      // Storage clearing is handled in the action, not here
      return { ...initialState };
    default:
      return state;
  }
};

export default authReducer;
